import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	getPeriods,
	getScenarioStatus,
	getUserCountries,
	reset
} from "./scenarioApprovalSlice";
import Table from "./Table";
import ScenarioDetails from "./ScenarioDetails";
import RejectScenarioModal from "./RejectScenarioModal";
import ButtonGroup from "./ButtonGroup";
import RejectSelectedModal from "./RejectSelectedModal";
import Comments from "./Comments";
import SharedComponent from "./SharedComponent";
import MessageForScenario from "./MessageForScenario";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Scenario() {
	const dispatch = useDispatch();
	const state = useSelector((state) => state.scenarioApproval);
	const {
		isLoading,
		countries,
		scenarioStatusList,
		periods,
		scenariosForApprovalTable,
		scenarioDetails,
		scenariosForApproval
	} = state;

	useEffect(() => {
		dispatch(reset("refresh"));
		if (countries.length === 0) {
			dispatch(getUserCountries());
		}
		if (scenarioStatusList.length === 0) {
			dispatch(getScenarioStatus());
		}
		if (periods.length === 0) {
			dispatch(getPeriods());
		}
	}, []);

	return (
		<Box>
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>
			<Box>
				<MessageForScenario />
			</Box>
			<CollapseSection title="Search for Scenario">
			<Form />
			<RejectScenarioModal />
			{scenariosForApproval?.length > 0 ? <Table /> : null}
			{scenariosForApproval?.length > 0 ? <ButtonGroup/> : null}
         <RejectSelectedModal/>
		 </CollapseSection>
		 <SharedComponent/>
			{scenarioDetails !== null ? <ScenarioDetails /> : null}
		 <CollapseSection title="Comments and attachments">
         <Comments/>
		 </CollapseSection>
		</Box>
	);
}
